var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphCaseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    strokeMiterlimit: 10,
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    viewBox: "0 0 30 30",
    width: "100%",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7423 9.20903C15.283 8.93031 14.717 8.93031 14.2577 9.20903L10.5995 11.4289C10.1401 11.7076 9.85715 12.2227 9.85715 12.7802L9.85715 17.2198C9.85715 17.7773 10.1401 18.2924 10.5995 18.5711L14.2577 20.791C14.717 21.0697 15.283 21.0697 15.7423 20.791L19.4006 18.5711C19.8599 18.2924 20.1429 17.7773 20.1429 17.2198L20.1429 12.7802C20.1429 12.2227 19.8599 11.7076 19.4006 11.4289L15.7423 9.20903Z",
    fill: "#5990e4",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8571 15C12.8571 13.8954 13.7526 13 14.8571 13C15.9617 13 16.8571 13.8954 16.8571 15C16.8571 16.1046 15.9617 17 14.8571 17C13.7526 17 12.8571 16.1046 12.8571 15Z",
    fill: "#ffffff",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphCaseIcon);
export default __webpack_public_path__ + "static/media/graphCaseIcon.188cf296b83c0514cdfeb4d57f1b3e0a.svg";
export { ForwardRef as ReactComponent };